export function transformDates(obj: unknown): unknown {
  if (obj === null || typeof obj !== "object") return obj
  if ("type" in obj && obj.type === "Conditions::DatetimeCondition") return obj

  if (Array.isArray(obj)) {
    return obj.map(transformDates)
  }

  const result = { ...obj } as Record<string, unknown>
  for (const key in result) {
    const value = result[key]
    if (
      typeof value === "string" &&
      /^\d{4}-\d{2}-\d{2}[T ]\d{2}:\d{2}:\d{2}(\.\d{1,9})?(Z|[+-]\d{2}:?\d{2})$/.test(value)
    ) {
      result[key] = new Date(value)
    } else if (typeof value === "object") {
      result[key] = transformDates(value)
    }
  }
  return result
}
